export const NODE_ENV = process.env.NODE_ENV;
export const ORDER_API_URL = process.env.REACT_APP_ORDER_API_URL;
export const PAYMENT_ORDER_API_URL =
  process.env.REACT_APP_PAYMENT_ORDER_API_URL;
export const PAYMENT_SECRET_KEY = process.env.REACT_APP_PAYMENT_SECRET_KEY;
export const name = process.env.REACT_APP_name;
export const RAZORPAY_CALLBACK_URL =
  process.env.REACT_APP_RAZORPAY_CALLBACK_URL;
export const optionsThemeColor = {
  color: process.env.REACT_APP_options_theme_color,
};
export const PAYU_CALLBACK_URL = process.env.REACT_APP_PAYU_CALLBACK_URL;
export const PAYU_KEY = process.env.REACT_APP_PAYU_KEY;
export const PAYU_URL = process.env.REACT_APP_PAYU_URL;

const RAZORPAY_KEY_MAP = {
  1: process.env.REACT_APP_LEARN_RAZORPAY_KEY_ID,
  2: process.env.REACT_APP_KH_RAZORPAY_KEY_ID,
};

export const GET_RAZORPAY_KEY_ID = (vertical_id) =>
  RAZORPAY_KEY_MAP[vertical_id];
